import { Injectable } from '@angular/core';
import { TrinityService } from 'app/services/trinity/trinity.service';
import { Observable } from 'rxjs';
import {
  BulkResponse,
  UpdateFilePropertiesOptions,
  UpdateFilesConfidentialityOptions,
  UpdateFilesTagsOptions,
} from 'app/types/bulk.types';
import { FileDto, FileLabel, TagDatamart } from '../../types';

@Injectable({
  providedIn: 'root',
})
export class BulkService {
  constructor(private trinityService: TrinityService) {}

  private readonly endpointFiles: string = '/bulk/files';

  updateFilesProperties(
    filesProperties: UpdateFilePropertiesOptions,
  ): Observable<BulkResponse<FileDto, string>> {
    return this.trinityService.put<BulkResponse<FileDto, string>>(
      `${this.endpointFiles}/properties`,
      {
        body: filesProperties,
        authorized: true,
      },
    );
  }

  updateFilesConfidentiality(
    filesConfidentiality: UpdateFilesConfidentialityOptions,
  ): Observable<BulkResponse<{ id: string; labels: FileLabel[] }, string>> {
    return this.trinityService.put<
      BulkResponse<{ id: string; labels: FileLabel[] }, string>
    >(`${this.endpointFiles}/confidentiality`, {
      body: filesConfidentiality,
      authorized: true,
    });
  }

  updateFileTags(
    filesTags: UpdateFilesTagsOptions,
  ): Observable<BulkResponse<{ id: string; tags: TagDatamart[] }, string>> {
    return this.trinityService.put<
      BulkResponse<{ id: string; tags: TagDatamart[] }, string>
    >(`${this.endpointFiles}/tags`, {
      body: filesTags,
      authorized: true,
    });
  }

  flagFiles(
    ids: string[],
    reason: string,
  ): Observable<BulkResponse<{ id: string; labels: FileLabel[] }, string>> {
    return this.trinityService.put<
      BulkResponse<{ id: string; labels: FileLabel[] }, string>
    >(`${this.endpointFiles}/flagged`, {
      body: {
        file_ids: ids,
        reason: reason,
      },
      authorized: true,
    });
  }

  unflagFiles(ids: string[]): Observable<BulkResponse<FileDto, string>> {
    return this.trinityService.delete<BulkResponse<FileDto, string>>(
      `${this.endpointFiles}/flagged`,
      {
        body: {
          file_ids: ids,
        },
        authorized: true,
      },
    );
  }
}
